import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { useInstanceSelector } from '@s20/hooks/redux.hooks';
import { checkUserHasPermission } from '@s20/selectors/features/permissions.selectors';
import { DispatchContext } from '../../../DispatchContext';
import { IconButton } from '../../../../../common/forms/FormElements';
import { ApplicationPermissions } from '../../../../../Common';
import { JobContext } from '../JobContext';
import { useCancelJobAssignment } from './useCancelJobAssignment.hook';

export const CancelJobAssignment = ({ jobAssignmentId, resourceType }) => {
    const { jobAssignmentCancellationTypes } = useContext(DispatchContext);
    const { job, day } = useContext(JobContext);

    const hasDispatchEditPermission = useInstanceSelector(checkUserHasPermission, ApplicationPermissions.dispatch_edit);

    const handleRemoveDayJob = useCancelJobAssignment({
        day, job, jobAssignmentCancellationTypes, jobAssignmentId,
    });

    return (
        <IconButton
            color="link"
            title={`Remove this ${resourceType}`}
            className="p-0"
            disabled={!hasDispatchEditPermission}
            onClick={handleRemoveDayJob}
        >
            <FontAwesomeIcon
                icon={faMinusCircle}
                className="text-danger"
            />
        </IconButton>
    );
};